export type RoundEndReason = 'KO' | 'TIME_UP' | 'DRAW';

export interface KoTheme {
  readonly text: string;
  readonly textColor: string;
  readonly strokeColor: string;
  readonly strokeThickness: number;
  readonly fontSize: string;
  readonly hasDim: boolean;
  readonly dimAlpha: number;
  readonly subText: string;
  readonly subColor: string;
  readonly cameraShake: { durationMs: number; intensity: number } | null;
}

export const KO_THEMES: Readonly<Record<RoundEndReason, KoTheme>> = Object.freeze({
  KO: Object.freeze({
    text: 'K.O.',
    textColor: '#ffffff',
    strokeColor: '#0f172a',
    strokeThickness: 8,
    fontSize: '92px',
    hasDim: true,
    dimAlpha: 0.25,
    subText: 'INCIDENT CLOSED',
    subColor: '#fca5a5',
    cameraShake: { durationMs: 120, intensity: 0.008 },
  }),
  TIME_UP: Object.freeze({
    text: 'TIME UP',
    textColor: '#fde047',
    strokeColor: '#0f172a',
    strokeThickness: 7,
    fontSize: '76px',
    hasDim: false,
    dimAlpha: 0,
    subText: 'TIME EXPIRED',
    subColor: '#fef08a',
    cameraShake: null,
  }),
  DRAW: Object.freeze({
    text: 'DRAW',
    textColor: '#93c5fd',
    strokeColor: '#0f172a',
    strokeThickness: 7,
    fontSize: '76px',
    hasDim: false,
    dimAlpha: 0,
    subText: 'NO WINNER',
    subColor: '#bfdbfe',
    cameraShake: null,
  }),
});
